export const TYPOGRAPHY_UNDERLINES_BASE = [
    '[&>span]:inline',
    '[&>span]:w-max',
    '[&>span]:border-b-heavy',
    '[&>span]:border-transparent',
    '[&>span]:border-solid',
    '[&>span]:[border-image-repeat:stretch]',
];
export const TYPOGRAPHY_UNDERLINES_THICKNESS = {
    2: ['[&>span]:[border-image-width:0_0_2px_0_!important]'],
    4: ['[&>span]:[border-image-width:0_0_4px_0_!important]'],
};
export const TYPOGRAPHY_UNDERLINE_VARIANTS = {
    rainbow: ['[&>span]:[border-image:1_theme(colors.gradient-rainbow-horizontal)]'],
    pink: ['[&>span]:[border-image:1_theme(colors.gradient-pink)]'],
    green: ['[&>span]:[border-image:1_theme(colors.gradient-green)]'],
    blue: ['[&>span]:[border-image:1_theme(colors.gradient-blue)]'],
    purple: ['[&>span]:[border-image:1_theme(colors.gradient-purple)]'],
};
